import { ForgotPasswordConstants as Constants } from "../types";

const initialState = {
	email: null,
	error: null,
	code: null,
	otpVerified: false,
	resetSuccess: false,
};

export function forgotPasswordReducer(state = initialState, action) {
	switch (action.type) {
		case Constants.REQUEST:
			const { email, message } = action.payload;
			return {
				...state,
				email: email,
				message: message,
				error: null,
			};
		case Constants.VERIFY_OTP_REQUEST:
			const { otpVerified, code } = action.payload;
			return {
				...state,
				code: code,
				otpVerified: otpVerified,
				error: null,
			};
		case Constants.VERIFY_OTP_FAILED:
			return {
				...state,
				error: action.error,
			};

		case Constants.RESEND_OTP_REQUEST:
			const { resendOtpVerified, otp } = action.payload;
			return {
				...state,
				code: otp,
				otpVerified: resendOtpVerified,
				error: null,
			};
		case Constants.RESEND_OTP_FAILED:
			return {
				...state,
				error: action.error,
			};

		case Constants.RESET_PASSWORD_REQUEST:
			const { resetPassword } = action.payload;
			return {
				...state,
				otpVerified: true,
				resetSuccess: resetPassword,
				error: null,
			};
		case Constants.RESET_PASSWORD_FAILED:
			return {
				...state,
				error: action.error,
			};
		case Constants.FAILED:
			return {
				...state,
				error: action.error,
			};

		default:
			return state;
	}
}
